import React from "react";
import { getNavIcon } from "./NavIcons";
import { btnActive, roundedPanel } from "./designTokens";

/** Liste de boutons de navigation (sidebar ou menu mobile). */
export function NavList({ items, isActive, onSelect, iconOnly }) {
  return (
    <>
      {items.map((item) => {
        const itemIsActive = isActive(item.path);
        return (
          <button
            key={item.id}
            onClick={() => onSelect(item.path)}
            className={`w-full flex items-center gap-3 px-3 py-5 ${roundedPanel} text-left transition-all duration-200 text-white ${
              itemIsActive
                ? btnActive
                : "hover:bg-white/20 dark:hover:bg-gray-600/50"
            } ${iconOnly ? "justify-center px-2" : ""}`}
            aria-current={itemIsActive ? "page" : undefined}
            title={iconOnly ? item.label : undefined}
          >
            {getNavIcon(item.icon)}
            {!iconOnly && (
              <span className="text-sm font-medium truncate">{item.label}</span>
            )}
          </button>
        );
      })}
    </>
  );
}
